import { render } from "./Page.vue?vue&type=template&id=81bbf20a"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/containers/Page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81bbf20a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81bbf20a', __exports__)) {
    api.reload('81bbf20a', __exports__)
  }
  
  module.hot.accept("./Page.vue?vue&type=template&id=81bbf20a", () => {
    api.rerender('81bbf20a', render)
  })

}


export default __exports__